export function splitMarkdownSections(markdown: string): string[] {
  const lines = markdown.split('\n');

  let topLevel = 6;
  for (const line of lines) {
    const match = /^(#{1,6})\s/.exec(line);
    if (match) topLevel = Math.min(topLevel, match[1].length);
  }

  const headingRegex = new RegExp(`^#{${topLevel}}\\s`);
  const sections: string[] = [];
  let current: string[] = [];

  for (const line of lines) {
    const startsNewSection = headingRegex.test(line) && current.some(l => l.trim().length > 0);
    if (startsNewSection) {
      sections.push(current.join('\n').trim());
      current = [line];
    } else {
      current.push(line);
    }
  }

  const last = current.join('\n').trim();
  if (last.length > 0) sections.push(last);

  return sections.length > 0 ? sections : [markdown.trim()];
}
